export const TITLE_FONT_SIZE = "2.5vw";
export const TEXT_FONT_SIZE = "1.6vw";
